import { render } from "./RichLevelUserInfoComponent.vue?vue&type=template&id=78c9eddc"
import script from "./RichLevelUserInfoComponent.vue?vue&type=script&lang=js"
export * from "./RichLevelUserInfoComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__